/**
 * L2-P2: moved to @miq/platform (services/user-info.resolver.ts). This shim keeps the old import
 * path working; new code should import from '@miq/platform'.
 */
export { userGroupEnum, UserInfoResolver, userInfoResolver } from '@miq/platform';
